<template>
  <div class="page">
    <div class="tab-wrap">
      <div class="tab-left">
        <div
          class="tab"
          :class="{ active: tabIndex === 0 }"
          @click="tabIndex = 0"
        >
          论文
        </div>
        <div
          class="tab"
          :class="{ active: tabIndex === 1 }"
          @click="tabIndex = 1"
        >
          图书
        </div>
      </div>
      <div
        class="filter-wrap"
        @click="handleFilterPannelShow"
      >
        <div class="filter-text">筛选</div>
        <van-icon
          class="filter"
          name="filter-o"
        />
      </div>
    </div>
    <van-pull-refresh
      class="list-wrap"
      v-show="tabIndex === 0"
      v-model="articleParam.refreshing"
      @refresh="handleArticleQuery(true)"
    >
      <van-list
        v-model="articleParam.loading"
        :finished="articleParam.finished"
        finished-text="没有更多数据"
        @load="handleArticleQuery"
        ref="articleList"
      >
        <div
          class="item"
          v-for="(item, index) in articleParam.list"
          :key="index"
          @click="hanldeArticleClick(item)"
        >
          <div
            class="text-wrap"
            v-if="item.articleTitle"
          >
            <div
              class="tit all van-multi-ellipsis--l2"
              v-text="item.articleTitle"
            ></div>
          </div>
          <div
            class="text-wrap"
            v-if="item.articleTitleEn && !item.articleTitle"
          >
            <div
              class="tit all van-multi-ellipsis--l2"
              v-text="item.articleTitleEn"
            ></div>
          </div>
          <div
            class="text-wrap"
            v-if="item.author.length > 0"
          >
            <div class="tit">作者：</div>
            <div
              class="con van-multi-ellipsis--l2"
              v-text="
                item.author.length <= 3
                  ? item.author.map((author) => author.name).join('、')
                  : item.author
                      .slice(0, 3)
                      .map((author) => author.name)
                      .join('、') + '...'
              "
            ></div>
          </div>
          <div
            class="text-wrap"
            v-if="item.publicationName"
          >
            <div class="tit">来源：</div>
            <div
              class="con van-multi-ellipsis--l2"
              v-text="item.publicationName"
            ></div>
          </div>
          <div
            class="text-wrap"
            v-if="item.pubYear"
          >
            <div class="tit">发表年度：</div>
            <div
              class="con van-multi-ellipsis--l2"
              v-text="item.pubYear"
            ></div>
          </div>
          <div
            class="text-wrap"
            v-if="item.aggWebHxId"
          >
            <div class="tit">收录数据库：</div>
            <div
              class="con van-multi-ellipsis--l2"
              v-text="item.aggWebHxId"
            ></div>
          </div>
          <div
            class="text-wrap"
            v-if="item.webSiteInfo"
          >
            <div class="tit">被引情况：</div>
            <div
              class="con van-multi-ellipsis--l2"
              v-text="item.webSiteInfo"
            ></div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-pull-refresh
      class="list-wrap"
      v-show="tabIndex === 1"
      v-model="bookParam.refreshing"
      @refresh="handleBookQuery(true)"
    >
      <van-list
        v-model="bookParam.loading"
        :finished="bookParam.finished"
        finished-text="没有更多数据"
        @load="handleBookQuery"
        ref="bookList"
      >
        <div
          class="item"
          v-for="(item, index) in bookParam.list"
          :key="index"
          @click="hanldeBookClick(item)"
        >
          <div
            class="text-wrap"
            v-if="item.bookTitle"
          >
            <div
              class="tit all van-multi-ellipsis--l2"
              v-text="item.bookTitle"
            ></div>
          </div>
          <div
            class="text-wrap"
            v-if="item.bookTitleEn && !item.bookTitle"
          >
            <div
              class="tit all van-multi-ellipsis--l2"
              v-text="item.bookTitleEn"
            ></div>
          </div>
          <div
            class="text-wrap"
            v-if="item.author.length > 0"
          >
            <div class="tit">作者：</div>
            <div
              class="con"
              v-text="item.author.map((author) => author.name).join('、')"
            ></div>
          </div>
          <div
            class="text-wrap"
            v-if="item.pressName"
          >
            <div class="tit">出版社：</div>
            <div
              class="con van-multi-ellipsis--l2"
              v-text="item.pressName"
            ></div>
          </div>
          <div
            class="text-wrap"
            v-if="item.pubYear"
          >
            <div class="tit">出版年：</div>
            <div
              class="con van-multi-ellipsis--l2"
              v-text="item.pubYear"
            ></div>
          </div>
          <div
            class="text-wrap"
            v-if="item.isbnNo"
          >
            <div class="tit">ISBN：</div>
            <div
              class="con van-multi-ellipsis--l2"
              v-text="item.isbnNo"
            ></div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-popup
      class="filter-pannel"
      close-on-popstate
      v-model="bookParam.filterShow"
      position="right"
    >
      <div class="filter-item-wrap">
        <div class="filter-item">
          <div class="filter-title">著作方式</div>
          <div class="filter-con">
            <div
              class="btn"
              :class="{
                active: item.value === bookParam.tempFilterParam.authorDuty,
              }"
              v-for="(item, index) in bookAuthorDutyList"
              :key="index"
              v-text="item.label"
              @click="bookParam.tempFilterParam.authorDuty = item.value"
            ></div>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-title">是否认领</div>
          <div class="filter-con">
            <div
              class="btn"
              :class="{
                active: item.value === bookParam.tempFilterParam.claimed,
              }"
              v-for="(item, index) in bookClaimedList"
              :key="index"
              v-text="item.label"
              @click="bookParam.tempFilterParam.claimed = item.value"
            ></div>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-title">开始出版年</div>
          <div class="filter-con">
            <div
              class="year-wrap"
              @click="bookParam.fromYearPopShow = true"
            >
              <div
                class="year"
                v-text="
                  bookParam.tempFilterParam.fromPubYear
                    ? bookParam.tempFilterParam.fromPubYear + '年'
                    : '未选择'
                "
              ></div>
              <van-icon
                class="arrow"
                name="arrow-down"
              />
            </div>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-title">结束出版年</div>
          <div class="filter-con">
            <div
              class="year-wrap"
              @click="bookParam.toYearPopShow = true"
            >
              <div
                class="year"
                v-text="
                  bookParam.tempFilterParam.toPubYear
                    ? bookParam.tempFilterParam.toPubYear + '年'
                    : '未选择'
                "
              ></div>
              <van-icon
                class="arrow"
                name="arrow-down"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="filter-bottom">
        <div
          class="btn btn-reset"
          @click="handleBookFilterReset"
        >重置</div>
        <div
          class="btn btn-sure"
          @click="handleBookFilterSure"
        >确认</div>
      </div>
    </van-popup>
    <van-popup
      class="filter-pannel"
      close-on-popstate
      v-model="articleParam.filterShow"
      position="right"
    >
      <div class="filter-item-wrap">
        <div class="filter-item">
          <div class="filter-title">成果类型</div>
          <div class="filter-con">
            <div
              class="btn"
              :class="{
                active: item.value === articleParam.tempFilterParam.sourceType,
              }"
              v-for="(item, index) in articleSourceTypeList"
              :key="index"
              v-text="item.label"
              @click="articleParam.tempFilterParam.sourceType = item.value"
            ></div>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-title">作者类型</div>
          <div class="filter-con">
            <div
              class="btn"
              :class="{
                active: item.value === articleParam.tempFilterParam.authorType,
              }"
              v-for="(item, index) in articleAuthOrTypeList"
              :key="index"
              v-text="item.label"
              @click="articleParam.tempFilterParam.authorType = item.value"
            ></div>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-title">排序字段</div>
          <div class="filter-con">
            <div
              class="btn"
              :class="{
                active: item.value === articleParam.tempFilterParam.sortFiled,
              }"
              v-for="(item, index) in articleSortFiledList"
              :key="index"
              v-text="item.label"
              @click="articleParam.tempFilterParam.sortFiled = item.value"
            ></div>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-title">排序规则</div>
          <div class="filter-con">
            <div
              class="btn"
              :class="{
                active: item.value === articleParam.tempFilterParam.sortType,
              }"
              v-for="(item, index) in articleSortTypeList"
              :key="index"
              v-text="item.label"
              @click="articleParam.tempFilterParam.sortType = item.value"
            ></div>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-title">是否认领</div>
          <div class="filter-con">
            <div
              class="btn"
              :class="{
                active: item.value === articleParam.tempFilterParam.claimed,
              }"
              v-for="(item, index) in articleClaimedList"
              :key="index"
              v-text="item.label"
              @click="articleParam.tempFilterParam.claimed = item.value"
            ></div>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-title">开始出版年</div>
          <div class="filter-con">
            <div
              class="year-wrap"
              @click="articleParam.fromYearPopShow = true"
            >
              <div
                class="year"
                v-text="
                  articleParam.tempFilterParam.fromPubYear
                    ? articleParam.tempFilterParam.fromPubYear + '年'
                    : '未选择'
                "
              ></div>
              <van-icon
                class="arrow"
                name="arrow-down"
              />
            </div>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-title">结束出版年</div>
          <div class="filter-con">
            <div
              class="year-wrap"
              @click="articleParam.toYearPopShow = true"
            >
              <div
                class="year"
                v-text="
                  articleParam.tempFilterParam.toPubYear
                    ? articleParam.tempFilterParam.toPubYear + '年'
                    : '未选择'
                "
              ></div>
              <van-icon
                class="arrow"
                name="arrow-down"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="filter-bottom">
        <div
          class="btn btn-reset"
          @click="handleArticleFilterReset"
        >重置</div>
        <div
          class="btn btn-sure"
          @click="handleArticleFilterSure"
        >确认</div>
      </div>
    </van-popup>
    <van-popup
      v-model="bookParam.fromYearPopShow"
      position="bottom"
    >
      <van-picker
        title="请选择开始出版年"
        show-toolbar
        :columns="bookParam.fromYearList"
        @cancel="bookParam.fromYearPopShow = false"
        @confirm="handleBookFromYearConfirm"
      />
    </van-popup>
    <van-popup
      v-model="bookParam.toYearPopShow"
      position="bottom"
    >
      <van-picker
        title="请选择结束出版年"
        show-toolbar
        :columns="bookParam.toYearList"
        @cancel="bookParam.toYearPopShow = false"
        @confirm="handleBookToYearConfirm"
      />
    </van-popup>
    <van-popup
      v-model="articleParam.fromYearPopShow"
      position="bottom"
    >
      <van-picker
        title="请选择开始出版年"
        show-toolbar
        :columns="articleParam.fromYearList"
        @cancel="articleParam.fromYearPopShow = false"
        @confirm="handleArticleFromYearConfirm"
      />
    </van-popup>
    <van-popup
      v-model="articleParam.toYearPopShow"
      position="bottom"
    >
      <van-picker
        title="请选择结束出版年"
        show-toolbar
        :columns="articleParam.toYearList"
        @cancel="articleParam.toYearPopShow = false"
        @confirm="handleArticleToYearConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import { getSelectList } from "@/api/common";
import {
  bookAchievementListGet,
  articleAchievementListGet,
} from "@/api/science-achieve";
import {
  STATUS_CODE_OK,
  T_DICT_BOOK_AUTHOR_DUTY,
  T_DICT_BOOK_CLAIMED,
  T_DICT_ARTICLE_SOURCETYPE,
  T_DICT_ARTICLE_AUTHORTYPE,
  T_DICT_ARTICLE_SORTFILED,
  T_DICT_ARTICLE_SORTTYPE,
  T_DICT_ARTICLE_CLAIMED,
} from "@/config";
import { setSessionStorage } from "@/utils";
export default {
  name: "ScienceAchieve",
  data() {
    return {
      bookAuthorDutyList: [], // 著作方式词典
      bookClaimedList: [], // 书籍是否认领词典
      articleSourceTypeList: [], // 成果类型词典
      articleAuthOrTypeList: [], // 作者类型词典
      articleSortFiledList: [], // 排序字段词典
      articleSortTypeList: [], // 排序规则词典
      articleClaimedList: [], // 论文是否认领词典
      tabIndex: 0, // 被选中的tab
      bookParam: {
        loading: false,
        finished: false,
        refreshing: false,
        pageNo: 1,
        pageSize: 20,
        list: [],
        filterShow: false,
        authorDuty: "",
        claimed: "",
        fromYearPopShow: false,
        fromYearList: [],
        fromPubYear: "",
        toYearPopShow: false,
        toYearList: [],
        toPubYear: "",
        tempFilterParam: {
          authorDuty: "",
          claimed: "",
          fromPubYear: "",
          toPubYear: "",
        },
      },
      articleParam: {
        loading: false,
        finished: false,
        refreshing: false,
        pageNo: 1,
        pageSize: 20,
        list: [],
        filterShow: false,
        sourceType: "",
        authorType: "",
        sortFiled: "",
        sortType: "",
        claimed: "",
        fromYearPopShow: false,
        fromYearList: [],
        fromPubYear: "",
        toYearPopShow: false,
        toYearList: [],
        toPubYear: "",
        tempFilterParam: {
          sourceType: "",
          authorType: "",
          sortFiled: "",
          sortType: "",
          claimed: "",
          fromPubYear: "",
          toPubYear: "",
        },
      },
    };
  },
  watch: {
    tabIndex() {
      this.$nextTick(() => {
        this.$refs.bookList && this.$refs.bookList.check();
        this.$refs.articleList && this.$refs.articleList.check();
      });
    },
  },
  async mounted() {
    this.handleReset();
    await this.handleBookAuthorDuty();
    await this.handleBookclaimed();
    await this.handleArticleSourceType();
    await this.handleArticleAuthOrType();
    await this.handleArticleSortFiled();
    await this.handleArticleSortType();
    await this.handleArticleClaimed();
    this.$nextTick(() => {
      this.$refs.bookList && this.$refs.bookList.check();
      this.$refs.articleList && this.$refs.articleList.check();
    });
  },
  methods: {
    // 重置
    handleReset() {
      this.bookAuthorDutyList = []; // 著作方式词典
      this.bookClaimedList = []; // 书籍是否认领词典
      this.articleSourceTypeList = []; // 成果类型词典
      this.articleAuthOrTypeList = []; // 作者类型词典
      this.articleSortFiledList = []; // 排序字段词典
      this.articleSortTypeList = []; // 排序规则词典
      this.articleClaimedList = []; // 论文是否认领词典
      this.tabIndex = 0; // 被选中的tab
      this.bookParam = {
        loading: false,
        finished: false,
        refreshing: false,
        pageNo: 1,
        pageSize: 20,
        list: [],
        filterShow: false,
        authorDuty: "",
        claimed: "",
        fromYearPopShow: false,
        fromYearList: [],
        fromPubYear: "",
        toYearPopShow: false,
        toYearList: [],
        toPubYear: "",
        tempFilterParam: {
          authorDuty: "",
          claimed: "",
          fromPubYear: "",
          toPubYear: "",
        },
      };
      this.articleParam = {
        loading: false,
        finished: false,
        refreshing: false,
        pageNo: 1,
        pageSize: 20,
        list: [],
        filterShow: false,
        sourceType: "",
        authorType: "",
        sortFiled: "",
        sortType: "",
        claimed: "",
        fromYearPopShow: false,
        fromYearList: [],
        fromPubYear: "",
        toYearPopShow: false,
        toYearList: [],
        toPubYear: "",
        tempFilterParam: {
          sourceType: "",
          authorType: "",
          sortFiled: "",
          sortType: "",
          claimed: "",
          fromPubYear: "",
          toPubYear: "",
        },
      };
      let nowYear = this.$moment().format("YYYY");
      for (let i = 0; i < 100; i++) {
        this.bookParam.fromYearList.push(nowYear - i);
        this.bookParam.toYearList.push(nowYear - i);
        this.articleParam.fromYearList.push(nowYear - i);
        this.articleParam.toYearList.push(nowYear - i);
      }
    },
    // 获取著作方式词典
    async handleBookAuthorDuty() {
      let { data } = await getSelectList({
        dictTable: T_DICT_BOOK_AUTHOR_DUTY,
      });
      if (data.code === STATUS_CODE_OK) {
        this.bookAuthorDutyList = data.data;
      }
    },
    // 获取书籍是否认领词典
    async handleBookclaimed() {
      let { data } = await getSelectList({
        dictTable: T_DICT_BOOK_CLAIMED,
      });
      if (data.code === STATUS_CODE_OK) {
        this.bookClaimedList = data.data;
      }
    },
    // 获取成果类型词典
    async handleArticleSourceType() {
      let { data } = await getSelectList({
        dictTable: T_DICT_ARTICLE_SOURCETYPE,
      });
      if (data.code === STATUS_CODE_OK) {
        this.articleSourceTypeList = data.data;
      }
    },
    // 获取作者类型词典
    async handleArticleAuthOrType() {
      let { data } = await getSelectList({
        dictTable: T_DICT_ARTICLE_AUTHORTYPE,
      });
      if (data.code === STATUS_CODE_OK) {
        this.articleAuthOrTypeList = data.data;
      }
    },
    // 获取排序字段词典
    async handleArticleSortFiled() {
      let { data } = await getSelectList({
        dictTable: T_DICT_ARTICLE_SORTFILED,
      });
      if (data.code === STATUS_CODE_OK) {
        this.articleSortFiledList = data.data;
      }
    },
    // 获取排序规则词典
    async handleArticleSortType() {
      let { data } = await getSelectList({
        dictTable: T_DICT_ARTICLE_SORTTYPE,
      });
      if (data.code === STATUS_CODE_OK) {
        this.articleSortTypeList = data.data;
      }
    },
    // 获取论文是否认领词典
    async handleArticleClaimed() {
      let { data } = await getSelectList({
        dictTable: T_DICT_ARTICLE_CLAIMED,
      });
      if (data.code === STATUS_CODE_OK) {
        this.articleClaimedList = data.data;
      }
    },
    // 显示过滤条件
    handleFilterPannelShow() {
      if (this.tabIndex === 0) {
        this.articleParam.tempFilterParam.sourceType =
          this.articleParam.sourceType;
        this.articleParam.tempFilterParam.authorType =
          this.articleParam.authorType;
        this.articleParam.tempFilterParam.sortFiled =
          this.articleParam.sortFiled;
        this.articleParam.tempFilterParam.sortType = this.articleParam.sortType;
        this.articleParam.tempFilterParam.claimed = this.articleParam.claimed;
        this.articleParam.tempFilterParam.fromPubYear =
          this.articleParam.fromPubYear;
        this.articleParam.tempFilterParam.toPubYear =
          this.articleParam.toPubYear;
        this.articleParam.filterShow = true;
      } else {
        this.bookParam.tempFilterParam.authorDuty = this.bookParam.authorDuty;
        this.bookParam.tempFilterParam.claimed = this.bookParam.claimed;
        this.bookParam.tempFilterParam.fromPubYear = this.bookParam.fromPubYear;
        this.bookParam.tempFilterParam.toPubYear = this.bookParam.toPubYear;
        this.bookParam.filterShow = true;
      }
    },
    // 书籍查询
    async handleBookQuery(isRefresh = false) {
      if (isRefresh) {
        this.bookParam.pageNo = 1;
        this.bookParam.loading = true;
        this.bookParam.finished = false;
      }
      let { data } = await bookAchievementListGet({
        pageNo: this.bookParam.pageNo,
        pageSize: this.bookParam.pageSize,
        authorDuty: this.bookParam.authorDuty,
        claimed: this.bookParam.claimed,
        fromPubYear: this.bookParam.fromPubYear,
        toPubYear: this.bookParam.toPubYear,
      });
      if (data.code === STATUS_CODE_OK) {
        this.bookParam.refreshing = false;
        this.bookParam.loading = false;
        this.bookParam.finished = !data.data.hasMore;
        this.bookParam.pageNo++;
        data.data.pageInfo = data.data.pageInfo.map((item) => {
          item.author = item.authorName.map((authorItem, index) => {
            return {
              name: authorItem ? authorItem : item.authorNameEn[index],
              isClaimed: item.authorClaimed[index],
              duty: item.authorDuty[index],
            };
          });
          return item;
        });
        if (isRefresh) {
          this.bookParam.list = data.data.pageInfo;
        } else {
          this.bookParam.list = this.bookParam.list.concat(data.data.pageInfo);
        }
      }
    },
    // 论文查询
    async handleArticleQuery(isRefresh = false) {
      if (isRefresh) {
        this.articleParam.pageNo = 1;
        this.articleParam.finished = false;
        this.articleParam.loading = true;
      }
      let { data } = await articleAchievementListGet({
        pageNo: this.articleParam.pageNo,
        pageSize: this.articleParam.pageSize,
        sourceType: this.articleParam.sourceType,
        authorType: this.articleParam.authorType,
        fromPubYear: this.articleParam.fromPubYear,
        toPubYear: this.articleParam.toPubYear,
        sortFiled: this.articleParam.sortFiled,
        sortType: this.articleParam.sortType,
        claimed: this.articleParam.claimed,
      });
      if (data.code === STATUS_CODE_OK) {
        this.articleParam.refreshing = false;
        this.articleParam.loading = false;
        this.articleParam.finished = !data.data.hasMore;
        this.articleParam.pageNo++;
        data.data.pageInfo = data.data.pageInfo.map((item) => {
          item.author = item.authorName.map((authorItem, index) => {
            return {
              name: authorItem ? authorItem : item.authorNameEn[index],
              isClaimed: item.authorClaimed[index],
            };
          });
          return item;
        });
        if (isRefresh) {
          this.articleParam.list = data.data.pageInfo;
        } else {
          this.articleParam.list = this.articleParam.list.concat(
            data.data.pageInfo
          );
        }
      }
    },
    // 图书开始出版年份pop确认
    handleBookFromYearConfirm(item) {
      this.bookParam.tempFilterParam.fromPubYear = item;
      this.bookParam.fromYearPopShow = false;
    },
    // 图书结束出版年份pop确认
    handleBookToYearConfirm(item) {
      this.bookParam.tempFilterParam.toPubYear = item;
      this.bookParam.toYearPopShow = false;
    },
    // 论文开始出版年份pop确认
    handleArticleFromYearConfirm(item) {
      this.articleParam.tempFilterParam.fromPubYear = item;
      this.articleParam.fromYearPopShow = false;
    },
    // 论文结束出版年份pop确认
    handleArticleToYearConfirm(item) {
      this.articleParam.tempFilterParam.toPubYear = item;
      this.articleParam.toYearPopShow = false;
    },
    // 图书过滤条件重置
    handleBookFilterReset() {
      this.bookParam.tempFilterParam.authorDuty = "";
      this.bookParam.tempFilterParam.claimed = "";
      this.bookParam.tempFilterParam.fromPubYear = "";
      this.bookParam.tempFilterParam.toPubYear = "";
    },
    // 图书过滤条件确认
    handleBookFilterSure() {
      this.bookParam.authorDuty = this.bookParam.tempFilterParam.authorDuty;
      this.bookParam.claimed = this.bookParam.tempFilterParam.claimed;
      this.bookParam.fromPubYear = this.bookParam.tempFilterParam.fromPubYear;
      this.bookParam.toPubYear = this.bookParam.tempFilterParam.toPubYear;
      this.bookParam.filterShow = false;
      this.handleBookQuery(true);
    },
    // 论文过滤条件重置
    handleArticleFilterReset() {
      this.articleParam.tempFilterParam.sourceType = "";
      this.articleParam.tempFilterParam.authorType = "";
      this.articleParam.tempFilterParam.sortFiled = "";
      this.articleParam.tempFilterParam.sortType = "";
      this.articleParam.tempFilterParam.claimed = "";
      this.articleParam.tempFilterParam.fromPubYear = "";
      this.articleParam.tempFilterParam.toPubYear = "";
    },
    // 论文过滤条件确认
    handleArticleFilterSure() {
      this.articleParam.sourceType =
        this.articleParam.tempFilterParam.sourceType;
      this.articleParam.authorType =
        this.articleParam.tempFilterParam.authorType;
      this.articleParam.sortFiled = this.articleParam.tempFilterParam.sortFiled;
      this.articleParam.sortType = this.articleParam.tempFilterParam.sortType;
      this.articleParam.claimed = this.articleParam.tempFilterParam.claimed;
      this.articleParam.fromPubYear =
        this.articleParam.tempFilterParam.fromPubYear;
      this.articleParam.toPubYear = this.articleParam.tempFilterParam.toPubYear;
      this.articleParam.filterShow = false;
      this.handleArticleQuery(true);
    },
    // 论文点击事件
    hanldeArticleClick(item) {
      setSessionStorage("queryParam", item);
      this.$router.push({
        path: "/myArticleDetail",
      });
    },
    // 图书点击事件
    hanldeBookClick(item) {
      setSessionStorage("queryParam", item);
      this.$router.push({
        path: "/myBookDetail",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  .tab-wrap {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    height: 58px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 666;
    border-bottom: 1px solid #eee;
    .tab-left {
      display: flex;
      align-items: center;
      .tab {
        color: #1282f4;
        padding: 8px 0;
        border: 1px solid #1282f4;
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.active {
          color: #fff;
          background-color: #1282f4;
        }
      }
    }
    .filter-wrap {
      display: flex;
      align-items: center;
      font-size: 16px;
      .filter {
        margin-left: 2px;
        font-size: 20px;
      }
    }
  }
  .list-wrap {
    position: fixed;
    left: 0;
    right: 0;
    top: 58px;
    bottom: 0;
    z-index: 666;
    overflow-y: auto;
    .item {
      background-color: #fff;
      margin-bottom: 10px;
      padding: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      .text-wrap {
        padding-bottom: 5px;
        display: flex;
        .tit {
          color: #000;
          flex: none;
          &.all {
            flex: 1;
            width: 0;
            font-weight: bolder;
            padding-bottom: 2px;
            color: #333;
          }
        }
        .con {
          color: #777;
          flex: 1;
          width: 0;
        }
        &:last-child {
          padding-bottom: 0;
        }
      }
    }
  }
  .filter-pannel {
    width: 260px;
    background-color: #f7f8fa;
    padding-bottom: 60px;
    height: 100%;
    .filter-item-wrap {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 60px;
      overflow-y: auto;
      .filter-item {
        margin-bottom: 10px;
        background-color: #fff;
        padding: 0 10px 10px 10px;
        &:last-child {
          margin-bottom: 0;
        }
        .filter-title {
          color: #000;
          padding: 10px 0;
        }
        .filter-con {
          display: flex;
          flex-wrap: wrap;
          .year-wrap {
            display: flex;
            align-items: center;
            .arrow {
              margin-left: 3px;
            }
          }
          .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #333;
            background-color: #eee;
            border-radius: 50px;
            min-width: 60px;
            padding: 0 10px;
            height: 30px;
            font-size: 12px;
            margin: 5px;
            &.active {
              background-color: #1282f4;
              color: #fff;
            }
          }
        }
      }
    }
    .filter-bottom {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        padding: 6px 12px;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #f96e2f;
        background-color: #fff;
        border: 1px solid #f96e2f;
        min-width: 100px;
        &.btn-sure {
          background-color: #f96e2f;
          color: #fff;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
